import React from 'react';

const About = () => (
  <div style={{ padding: '40px 24px', backgroundColor: '#f9f9f9', minHeight: '100vh' }}>
    <div style={{ maxWidth: 800, margin: '0 auto', textAlign: 'center' }}>
      <h1 style={{ fontSize: 36, color: '#203a43', marginBottom: 20 }}>About ZaziApp</h1>
      <p style={{
        fontSize: 18, 
        color: '#555', 
        lineHeight: 1.6, 
        marginBottom: 40,
        maxWidth: 700, 
        margin: '0 auto',
      }}>
        <strong>ZaziApp</strong> is a passionate team on a mission to bridge the gap for students who face disadvantages in accessing higher education. We believe that every young person deserves a fair chance to pursue their dreams, regardless of background or circumstance.
        <br /><br />
        Our platform is designed to break down barriers by providing easy access to bursaries, scholarships, and financial aid opportunities. We empower students with the information, tools, and support they need to unlock their full potential and build a brighter future.
      </p>

      <h2 style={{ fontSize: 24, color: '#203a43', marginBottom: 10 }}>Our Mission</h2>
      <p style={{ fontSize: 17, color: '#555', lineHeight: 1.6, marginBottom: 30, maxWidth: 700, margin: '0 auto' }}>
        Our mission is to level the playing field for all students by making higher education more accessible and attainable. We are committed to supporting learners from underrepresented and disadvantaged backgrounds, helping them overcome obstacles and achieve academic success.
      </p>

      <h2 style={{ fontSize: 24, color: '#203a43', marginBottom: 10 }}>Meet the Team</h2>
      <p style={{ fontSize: 17, color: '#555', lineHeight: 1.6, marginBottom: 30, maxWidth: 700, margin: '0 auto' }}>
        ZaziApp is currently led by a business analytics graduate (IT) who comes from a disadvantaged background. This personal experience drives a deep understanding of the challenges many students face when trying to access higher education. The vision and commitment behind ZaziApp are rooted in a genuine desire to make a difference and to open doors for others who might otherwise be left behind.
      </p>
      
      <h2 style={{ fontSize: 28, color: '#203a43', marginBottom: 10 }}>Why Choose Us?</h2>
      <ul style={{ listStyle: 'none', padding: 0, color: '#555', fontSize: 16, textAlign: 'left', maxWidth: 700, margin: '0 auto' }}>
        <li style={{ marginBottom: 10 }}>
          <strong>Personalized Recommendations:</strong> Get tailored suggestions based on your profile and preferences.
        </li>
        <li style={{ marginBottom: 10 }}>
          <strong>Data-Driven Insights:</strong> Our platform provides useful tips and tricks to enhance your chances of success.
        </li>
        <li style={{ marginBottom: 10 }}>
          <strong>Simple and Intuitive:</strong> Navigate effortlessly and find bursaries and resources quickly.
        </li>
      </ul>
      
      <div style={{ marginTop: 40, textAlign: 'center' }}>
        <a
          href="/"
          style={{
            backgroundColor: '#203a43',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: 8,
            fontSize: 16,
            textDecoration: 'none',
            fontWeight: 600,
            transition: 'background-color 0.3s',
          }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#2c5364'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#203a43'}
        >
          Go Back to Home
        </a>
      </div>
    </div>
  </div>
);

export default About;
